import styled from 'styled-components';
import { StyledProps } from 'types/styles';
import {
  Container as StyledContainer,
  Row as StyledRow,
  Col as StyledCol,
  Hidden as StyledHidden,
} from 'react-awesome-styled-grid';
import {
  typography,
  color,
  space,
  position,
  flexbox,
  layout,
  border,
  zIndex,
  background,
  shadow,
  display,
  borderRadius,
} from 'styled-system';

interface Props extends StyledProps {
  borderTopStyle?: string;
}

export const Container = styled(StyledContainer)<Props>`
  ${layout}
  ${color}
  ${space}
  ${border}
`;

export const Row = styled(StyledRow)<Props>`
  ${border}
  ${space}
  ${layout}
  ${position}
  ${flexbox}
  flex: 0 1 auto;
  flex-shrink: 0;
`;

export const Col = styled(StyledCol)<Props>`
  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${layout}
  ${display}
  ${border}
`;

export const Hidden = styled(StyledHidden)``;

export const RowStyled = styled.div<Props>`
  ${layout}
  ${flexbox}
  ${space}
`;

RowStyled.defaultProps = {
  display: 'flex',
  flexDirection: ['column', 'row'],
  flexShrink: '0',
  flex: '0 1 auto',
};

export const ColStyled = styled.div<Props>`
  ${layout}
  ${flexbox}
  ${space}
`;

ColStyled.defaultProps = {
  display: 'flex',
  flexDirection: 'column',
};

export const FlexRow = styled.div<Props>`
  display: flex;
  ${border}
  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${layout}
  ${display}
  ${typography}
  ${position}
`;

FlexRow.defaultProps = {
  flexDirection: ['row'],
};

export const FlexCol = styled.div<Props>`
  display: flex;
  flex-direction: column;
  ${border}

  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${border}
  ${layout}
  ${display}
  ${border}
`;

export const DefaultPageSubheader = styled.div<Props>`
  ${color}
  ${space}
  ${layout}
  ${flexbox}
  ${typography}
`;

DefaultPageSubheader.defaultProps = {
  display: 'flex',
  minHeight: '65px',
};

export const DefaultPageTabs = styled.div<Props>`
  ${color}
  ${space}
  ${layout}
  ${flexbox}
  ${typography}
`;

DefaultPageTabs.defaultProps = {
  bg: 'blacks.1',
  display: 'flex',
  minHeight: '24px',
  color: 'whites.0',
  pb: 2,
};

export const DefaultPageWrapper = styled.main<Props>`
  ${color}
  ${layout}
  ${flexbox}
  overflow-y: auto;
  height: 100%;
  width: 100%;
`;

DefaultPageWrapper.defaultProps = {
  bg: 'white',
};

export const DefaultPageContent = styled(Container)<Props>`
  ${color}
  ${layout}
  ${position}
  ${zIndex}
  ${space}
  ${background}
`;

DefaultPageContent.defaultProps = {
  color: 'blacks.1',
  zIndex: 0,
  flexBasis: '0',
  flexGrow: '1',
  position: 'relative',
  minWidth: '0',
  maxWidth: '100%',
  flexDirection: 'column',
  pt: 6,
  pb: '120px',
};

export const SubNavWrapper = styled.div<Props>`
  ${color}
  ${flexbox}
  ${layout}
  ${space}
`;

SubNavWrapper.defaultProps = {
  px: 6,
};

export const SidebarPageWrapper = styled.div<Props>`
  ${space}
  ${position}
  ${flexbox}
  ${layout}
  ${color}
`;

SidebarPageWrapper.defaultProps = {
  justifyContent: 'center',
  alignItems: 'stretch',
  zIndex: 0,
  flexGrow: '1',
  flexDirection: 'row',
  height: '100%',
  display: 'flex',
  bg: 'whites.0',
};

export const Sidebar = styled.div<Props>`
  ${typography}
  ${color}
  ${space}
  ${position}
  ${layout}
  ${flexbox}
  ${border}

  display: flex;
  height: calc(100vh - 60px);
  overflow: auto;
`;

Sidebar.defaultProps = {
  fontSize: 1,
  color: 'blacks.1',
  width: '400px',
  zIndex: 0,
  flexShrink: '0',
  minWidth: '0',
  maxWidth: '100%',
  flexDirection: 'column',
  bg: 'whites.0',
  p: 4,
};

export const SidebarPageContent = styled(Container)<Props>`
  ${position}
  ${flexbox}
  ${space}
  ${color}
  display: flex;
  height: calc(100vh - 60px);
  overflow: auto;
`;

SidebarPageContent.defaultProps = {
  color: 'blacks.1',
  bg: 'whites.0',
  zIndex: 0,
  flexBasis: '0',
  flexGrow: '1',
  position: 'relative',
  minWidth: '0',
  maxWidth: '100%',
  flexDirection: 'column',
  py: 5,
  px: 6,
};

export const Div = styled.div<Props>`
  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${layout}
  ${shadow}
  ${display}
  ${border}
  ${position}
  ${typography}
  ${borderRadius}
  ${zIndex}
`;

export const Span = styled.span<Props>`
  ${typography}
  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${layout}
  ${shadow}
  ${display}
  ${border}
  ${position}
`;

export const ImageWrapper = styled.img<Props>`
  ${border}
  ${space}
  ${layout}
`;

export const IconWrapper = styled.div<Props>`
  display: flex;
  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${layout}
  ${display}

  svg {
    ${layout}
  }
`;

IconWrapper.defaultProps = {
  height: 4,
  width: 4,
};
